import {FilterSelect, FilterSelectProps} from '@widgets/common-filters'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {COST_LEADERSHIP_FILTER_VALUES, CostLeadershipFilterValue} from '../../types'

export const PomCostLeadershipFilter = <TName extends string>({
  ...props
}: Omit<FilterSelectProps<CostLeadershipFilterValue, TName>, 'options'>) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const options = COST_LEADERSHIP_FILTER_VALUES.map((value) => ({
    value,
    label: t(`pomAction.costLeadership.${value}`)
  }))

  return <FilterSelect {...props} options={options} />
}
